export default [
  {
    path: '/customize',
    component: () => import('@/views/customizePage/index.vue'),
    name: 'customize',
    meta: {
      title: '自定义页面',
    },
  },
];
